import styled from 'styled-components'
import styledMap from 'styled-map'
import { margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

type StyledCaptionProps = MarginProps & {
  danger?: boolean
  success?: boolean
}

const colorMap = styledMap({
  default: themeGet('colors.text.muted'),
  success: themeGet('colors.success400'),
  danger: themeGet('colors.danger400'),
})

export const StyledCaption = styled.div<StyledCaptionProps>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  font-size: 12px;
  color: ${colorMap};

  ${margin};

  > svg {
    fill: ${colorMap};
  }
`
